import { Callout, PageHeader } from '@bifeai/ui';
import { Link } from 'react-router';
import { useSession } from '../lib/session';

/**
 * La casa central eligió una franquicia en el selector: sus chats, pedidos y clientes son de la franquicia
 * (la base no se los muestra a la central). Se avisa en vez de mostrar una pantalla vacía.
 */
export function FranchisePrivate({ title, what }: { title: string; what: string }) {
  const { privateFranchise } = useSession();
  return (
    <>
      <PageHeader title={title} />
      <Callout>
        {what} de {privateFranchise?.name ?? 'esta franquicia'} son privados de la franquicia: la casa central no los ve. Sus ventas y sus números
        están en <Link to="/franquicias">Franquicias</Link>.
      </Callout>
    </>
  );
}
